import Cookies from 'js-cookie';
import type { AuthResponse } from '@/apis/auth/auth.type';

const ADMIN_AUTH_TOKEN = 'admin_auth_token';
const ADMIN_AUTH_DATA = 'admin_auth_data';
const ADMIN_AUTH_EXPIRES = 'admin_auth_expires';

const BUSINESS_A_AUTH_TOKEN = 'business_a_auth_token';
const BUSINESS_A_AUTH_DATA = 'business_a_auth_data';
const BUSINESS_A_AUTH_EXPIRES = 'business_a_auth_expires';

const BUSINESS_B_AUTH_TOKEN = 'business_b_auth_token';
const BUSINESS_B_AUTH_DATA = 'business_b_auth_data';
const BUSINESS_B_AUTH_EXPIRES = 'business_b_auth_expires';

export const setAdminAuthCookies = (
  token: string,
  user: AuthResponse | any,
  expires: Date
) => {
  const cookieOptions = {
    expires,
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax' as const
  };
  
  Cookies.set(ADMIN_AUTH_TOKEN, token, cookieOptions);
  Cookies.set(ADMIN_AUTH_DATA, JSON.stringify(user), cookieOptions);
  Cookies.set(ADMIN_AUTH_EXPIRES, expires.toISOString(), cookieOptions);
};

export const clearAdminAuthCookies = () => {
  Cookies.remove(ADMIN_AUTH_TOKEN, { path: '/' });
  Cookies.remove(ADMIN_AUTH_DATA, { path: '/' });
  Cookies.remove(ADMIN_AUTH_EXPIRES, { path: '/' });
};

export const getAdminAuthData = () => {
  const token = Cookies.get(ADMIN_AUTH_TOKEN);
  const userData = Cookies.get(ADMIN_AUTH_DATA);
  const expires = Cookies.get(ADMIN_AUTH_EXPIRES);

  return {
    token,
    user: userData ? JSON.parse(userData) : null,
    expires: expires ? new Date(expires) : null,
  };
};

export const setBusinessACookies = (
  token: string,
  userData: any,
  expiration: Date
) => {
  Cookies.set(BUSINESS_A_AUTH_TOKEN, token, {
    expires: expiration,
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
  });
  Cookies.set(BUSINESS_A_AUTH_DATA, JSON.stringify(userData), {
    expires: expiration,
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
  });
  Cookies.set(BUSINESS_A_AUTH_EXPIRES, expiration.toISOString(), {
    expires: expiration,
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
  });
};

export const setBusinessBCookies = (
  token: string,
  userData: any,
  expiration: any
) => {
  Cookies.set(BUSINESS_B_AUTH_TOKEN, token, {
    expires: expiration.Time,
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
  });
  Cookies.set(BUSINESS_B_AUTH_DATA, JSON.stringify(userData), {
    expires: expiration.Time,
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
  });
  Cookies.set(BUSINESS_B_AUTH_EXPIRES, expiration.Time, {
    expires: expiration.Time,
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
  });
};

export const clearBusinessCookies = () => {
  Cookies.remove(BUSINESS_A_AUTH_TOKEN, { path: '/' });
  Cookies.remove(BUSINESS_A_AUTH_DATA, { path: '/' });
  Cookies.remove(BUSINESS_A_AUTH_EXPIRES, { path: '/' });

  Cookies.remove(BUSINESS_B_AUTH_TOKEN, { path: '/' });
  Cookies.remove(BUSINESS_B_AUTH_DATA, { path: '/' });
  Cookies.remove(BUSINESS_B_AUTH_EXPIRES, { path: '/' });
};

export const getBusinessAAuthData = () => {
  const token = Cookies.get(BUSINESS_A_AUTH_TOKEN);
  const userData = Cookies.get(BUSINESS_A_AUTH_DATA);
  const expires = Cookies.get(BUSINESS_A_AUTH_EXPIRES);

  return {
    token,
    user: userData ? JSON.parse(userData) : null,
    expires: expires ? new Date(expires) : null,
  };
};

export const getBusinessBAuthData = () => {
  const token = Cookies.get(BUSINESS_B_AUTH_TOKEN);
  const userData = Cookies.get(BUSINESS_B_AUTH_DATA);
  const expires = Cookies.get(BUSINESS_B_AUTH_EXPIRES);

  return {
    token,
    user: userData ? JSON.parse(userData) : null,
    expires: expires ? new Date(expires) : null,
  };
};

export const hasAuthExpired = () => {
  const now = new Date();

  const adminAuth = getAdminAuthData();
  const businessAAuth = getBusinessAAuthData();
  const businessBAuth = getBusinessBAuthData();

  const hasAnyToken =
    adminAuth.token || businessAAuth.token || businessBAuth.token;

  if (!hasAnyToken) {
    return true;
  }
  if (adminAuth.token && adminAuth.expires && adminAuth.expires <= now) {
    return true;
  }

  if (
    businessAAuth.token &&
    businessAAuth.expires &&
    businessAAuth.expires <= now
  ) {
    return true;
  }

  if (
    businessBAuth.token &&
    businessBAuth.expires &&
    businessBAuth.expires <= now
  ) {
    return true;
  }

  return false;
};
